import React, { useContext } from 'react';
import { IFrame as Iframe, TmoCard } from '@tmobile/tmo-bps-syncup-web-component-lib';

import config from '../../../configs/config';
import SyncUpProductContext from '../../../context/SyncUpProductContext';

const {
  iframeDevicesMapPetsURL,
  iframeDevicesMapTrackerURL,
  iframeDevicesMapWatchURL
} = config.powerBiSettings;

function DevicesMap() {
  const syncUpProductContext = useContext(SyncUpProductContext);
  const iframe = () => {
    switch (syncUpProductContext.syncUpAppName) {
      case 'TRACKER':
        return iframeDevicesMapTrackerURL;
      case 'KIDSWATCH':
        return iframeDevicesMapWatchURL;
      default:
        return iframeDevicesMapPetsURL;
    }
  };

  return (
    <TmoCard>
      <Iframe src={iframe()} width="100%" height="836px" />
    </TmoCard>
  );
}

export default DevicesMap;
